module.exports = __webpack_public_path__ + "static/media/microcontroller.48bff8b0.jpg";